import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import LicenseSetup from './LicenseSetup';
import { ta, setAdminLang, loadStoredAdminLang, storeAdminLang } from '../../i18n/adminT';

export default function AdminAuthGate() {
  const [status, setStatus] = useState('checking'); // checking | authenticated | anonymous
  const [me, setMe] = useState(null);
  const [licenseStatus, setLicenseStatus] = useState(null);

  const checkLicense = async () => {
    try {
      const data = await api.getLicenseStatus();
      setLicenseStatus(data);
      return data;
    } catch {
      // se anche lo stato non risponde, trattiamo come non valida per prudenza
      const fallback = { valid: false, reason: ta('Impossibile verificare la licenza.') };
      setLicenseStatus(fallback);
      return fallback;
    }
  };

  const checkSession = async () => {
    await checkLicense();
    try {
      const data = await api.me();
      setMe(data);
      if (data.language) storeAdminLang(data.language);
      setStatus('authenticated');
    } catch {
      setStatus('anonymous');
    }
  };

  useEffect(() => { checkSession(); }, []);

  // Cambia la lingua del proprio account: salvata sul server e ricordata
  // in questo browser per le schermate prima del login.
  const handleLanguageChange = async (language) => {
    try {
      await api.setMyLanguage(language);
    } catch {
      return; // non salvata: si resta nella lingua attuale
    }
    storeAdminLang(language);
    setMe((current) => ({ ...current, language }));
  };

  const handleLogout = async () => {
    await api.logout();
    setStatus('anonymous');
    setMe(null);
  };

  // La lingua va impostata prima del render dei figli (variabile di modulo)
  setAdminLang(me?.language || loadStoredAdminLang());

  if (status === 'checking') return null;

  if (status === 'anonymous') {
    return <AdminLogin onLoginSuccess={checkSession} />;
  }

  if (licenseStatus && !licenseStatus.valid) {
    return (
      <LicenseSetup
        me={me}
        licenseStatus={licenseStatus}
        onActivated={checkLicense}
        onLogout={handleLogout}
      />
    );
  }

  return <AdminDashboard me={me} onLogout={handleLogout} onLanguageChange={handleLanguageChange} licenseFeatures={licenseStatus?.features || []} />;
}
